import {t} from '@lingui/core/macro';

export const MONITORS_MAX = 15;

export interface IMonitorRef {
    monitor_id: string,
    monitor_name?: string | null,
    monitor_url: string,
}

export const validateMonitorsSelection = (value: string[]): string | true => {
    if (!value || value.length === 0) {
        return t`Выберите хотя бы один монитор`;
    }
    if (value.length > MONITORS_MAX) {
        return t`Можно выбрать не более ${MONITORS_MAX} мониторов`;
    }
    return true;
};

export const buildMonitorLabels = (monitors: IMonitorRef[]): Record<string, string> => (
    monitors.reduce<Record<string, string>>((labels, m) => {
        labels[m.monitor_id] = m.monitor_name?.trim() || m.monitor_url;
        return labels;
    }, {})
);
